import * as Actions from '../actions';

export default function cookieDataReducer(state = {}, action) {
	switch (action.type) {
		case Actions.GET_COOKIE_DATA_COMPLETE:
			return action.cookieData;
		default:
			return state;
	}
}

